import React, { useEffect, useState } from 'react'
import { useParams, useHistory, useLocation } from 'react-router-dom'

import styles from './UserController.module.sass'
import { useFetchList } from 'store'

import User from 'models/User'
import Widget from '@jimmyboys/liita-ui/dist/components/Widget'
import ExpandableWidget from 'components/ExpandableWidget/ExpandableWidget'
import Checkbox from '@jimmyboys/liita-ui/dist/components/Checkbox'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import useSession from 'hooks/useSession'
import { useDeepCompareEffect } from 'react-use'
import Dropdown from '@jimmyboys/liita-ui/dist/components/Dropdown'
import UsersRulesEditorController from 'controllers/Settings/RulesEditorController/UsersRulesEditorController'
import useQueryParams from '@jimmyboys/liita-ui/dist/hooks/useQueryParams'

const renderRoleType = (roleType, data, title) => {
	return data && data.length ? (
		<ExpandableWidget
			key={roleType}
			className={styles['tag-widget']}
			titleAppearance='aside-widget'
			arrowPosition='right'
			heading='small'
			title={title}
			collapsedLabel={data.length}
			expanded={true}
			expandable={true}
			borderRadius
			margins={['small', '', '']}
			paddings={['small', '', '']}
			useMaxWidth
		>
			<div className={styles['type-grid']}>
				{data.map(({ name }, idx) => {
					return (
						<Checkbox
							key={idx}
							className={styles['checkbox']}
							name={'notify manager'}
							label={name}
							checked={true}
							disabled
						/>
					)
				})}
			</div>
		</ExpandableWidget>
	) : null
}

const UserExclusionRulesController = () => {
	const { i18n } = useGlobal()
	const params = useParams()
	const { user: sessionUser } = useSession()
	const userDataUri = `/users/${params.userId}`
	const history = useHistory()

	const location = useLocation()
	const [searchParams] = useQueryParams(location)

	const rulesOptions = [
		{
			text: i18n`Triage opinion`,
			value: 'triage-opinion',
		},
		{
			text: i18n`Triage opinion - Follow up`,
			value: 'triage-opinion-followup',
		},
		{
			text: i18n`Transfer opinion`,
			value: 'transfer-opinion',
		},
		{
			text: i18n`Causal link opinion`,
			value: 'causal-link-opinion',
		},
		{
			text: i18n`Clinical followup opinion`,
			value: 'clinical-followup-opinion',
		},
		{
			text: i18n`Relapse opinion`,
			value: 'relapse-opinion',
		},
		{
			text: i18n`Medical acts clinical evaluation`,
			value: 'medical-acts-clinical-approval',
		},
		{
			text: i18n`Appointment clinical approval`,
			value: 'appointment-clinical-approval',
		},
		{
			text: i18n`Surgery clinical approval`,
			value: 'surgery-clinical-approval',
		},
		{
			text: i18n`Relapse clinical approval`,
			value: 'relapse-clinical-approval',
		},
		{
			text: i18n`Transfer clinical approval`,
			value: 'transfer-clinical-approval',
		},
		{
			text: i18n`Final situation prevision`,
			value: 'final-situation-prevision',
		},
		{
			text: i18n`Non Surgical Admission`,
			value: 'non-surgical-admission-requisition',
		},
		{
			text: i18n`Process forwarding`,
			value: 'process-forwarding',
		},
		{
			text: i18n`Ticket`,
			value: 'ticket',
		},
	]

	const taskType =
		params?.taskType ?? searchParams.taskType ?? rulesOptions[0].value

	const roleTypesTranslations = {
		processType: i18n`Process type`,
		insuranceCompany: i18n`Insurance Company`,
		bodyPart: i18n`Body part`,
	}

	const requests = (sessionUser?.roles || []).includes('admin')
		? [userDataUri, `/metadata/user_tags`]
		: [userDataUri]

	const {
		contents: [userData],
	} = useFetchList(requests, [User.fromJSON])

	const [selectedRole, setSelectedRole] = useState(null)

	const rolesOptions = [
		{
			value: 'Codification',
			text: i18n`Codification`,
		},
		{
			value: 'Triage',
			text: i18n`Triage`,
		},
	]

	const user = userData || {}

	useDeepCompareEffect(() => {
		const firstUserRole = user?.roles?.find(
			(f) =>
				f.id !== 'admin' &&
				rolesOptions.map((elem) => elem.value).includes(f.id)
		)
		if (firstUserRole && firstUserRole !== '') {
			setSelectedRole((prev) => prev || firstUserRole.id)
		}
	}, [user])

	useEffect(
		() => () => {
			setSelectedRole(null)
		},
		[params.userId]
	)

	let tagNameByTypeByRole = {}
	return (
		<>
			<Widget>
				<Dropdown
					value={taskType}
					options={rulesOptions}
					onChange={(e) => {
						history.replace(
							`/users/${params?.userId}/user-exclusion/?taskType=${e.target.value}`
						)
					}}
				/>
				<div className={styles['editor-container']}>
					<UsersRulesEditorController
						userRules
						userId={user?.username}
						taskType={taskType}
					/>
				</div>
			</Widget>
			<Widget margins={['', 'normal', '']} applyMaxWidth>
				{renderRoleType(
					'processType',
					tagNameByTypeByRole[selectedRole]?.['processType'] || [],
					roleTypesTranslations['processType']
				)}
				{renderRoleType(
					'insuranceCompany',
					tagNameByTypeByRole[selectedRole]?.['insuranceCompany'] ||
						[],
					roleTypesTranslations['insuranceCompany']
				)}
				{renderRoleType(
					'bodyPart',
					tagNameByTypeByRole[selectedRole]?.['bodyPart'] || [],
					roleTypesTranslations['bodyPart']
				)}
			</Widget>
		</>
	)
}

export default UserExclusionRulesController
